import type { PaymentTypes } from 'commons/constants/paymentTypes'

export type PaymentSubmitRequest = {
	requestPubUuid: string
	amount: number
	paymentType: PaymentTypes
	formValues: string
}

export type PaymentRequestResponse = {
	success?: boolean
	request_pub_uuid?: string | false
	url?: string
	error_message?: string
}

export type PaymentFlowResponse = {
	environment: 'production' | 'sandbox'
	payment_session_id?: string
	payment_session_token?: string
	public_key?: string
	success: boolean
	url?: string
}

export type VerifyIdentityResponse = {
	success: boolean
	message?: string
}

export type PaymentRedirectResponse = {
	success: boolean
	error?: boolean
	message?: string
	url: string
}

export type WalletBillingAddress = {
	firstname: string
	lastname: string
	address1: string
	address2: string
	address3: string
	city: string
	country: string
	zipcode: string
}

export type XPayResponse = {
	id: string
	status: string
	type: string
}

export enum FormStep {
	STEP_NAME = 'name',
	STEP_BIRTHDATE = 'birthdate'
}
